module.exports = __webpack_public_path__ + "static/media/biriyani.03a50adc.jpg";